import * as React from 'react'

import { styled } from '../../../common/ui'
import { theme } from '../theme'

export class ErrorAlert extends React.Component<
  { errors: string[]; title?: string },
  {}
> {
  static defaultProps = {
    title: 'Wystąpiły następujące błędy w formularzu',
  }
  public render() {
    const { title, errors } = this.props
    return errors.length > 0 ? (
      <Container>
        {title && <Title>{title}</Title>}
        <List>
          {errors.map((error, i) => (
            <Item key={String(i)}>{error}</Item>
          ))}
        </List>
      </Container>
    ) : null
  }
}

const Container = styled.div`
  padding: 25px;
  margin-bottom: 25px;
  background-color: ${theme.colors.red};
`
const List = styled.ol`
  padding: 0;
  margin: 0 0 0 20px;
`
const Item = styled.li`
  padding: 0;
  margin: 0 0 10px 0;
  color: #fff;
`
const Title = styled.h4`
  padding: 0;
  margin: 0 0 20px 0;
  color: #fff;
`
